'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputError = function (_PureComponent) {
  _inherits(InputError, _PureComponent);

  function InputError() {
    _classCallCheck(this, InputError);

    return _possibleConstructorReturn(this, (InputError.__proto__ || Object.getPrototypeOf(InputError)).apply(this, arguments));
  }

  _createClass(InputError, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          errors = _props.errors;

      if (errors.length === 0) {
        return null;
      }
      return _react2.default.createElement(
        'span',
        { className: 'InputError ' + className },
        errors[0]
      );
    }
  }]);

  return InputError;
}(_react.PureComponent);

InputError.propTypes = {
  className: _propTypes2.default.string.isRequired,
  errors: _propTypes2.default.array.isRequired
};

InputError.defaultProps = {
  className: ''
};

exports.default = InputError;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/InputError.js
// module id = 458
// module chunks = 0